(function () {
  const Core = window.RB.Core;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Protective Sands": {
      triggers: [
        {
          on: "conquer",
          selfBf: true,
          you: true,
          label: "when you conquer here",
          targets: [],
          program: [
            {
              op: "if",
              cond: { k: "runesMax", n: 4 },
              then: [
                {
                  op: "may",
                  prompt: "Pay [energy_1]?",
                  then: [
                    {
                      op: "payCost",
                      cost: { energy: 1, pips: 0, anyPower: 0, domains: null },
                      skipOnFail: 1,
                    },
                    { op: "draw", n: 1 },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },

    "Shadow Temple": {
      triggers: [
        {
          on: "hold",
          selfBf: true,
          you: true,
          label: "when you hold here",
          targets: [],
          program: [{ op: "burn", n: 3 }],
        },
      ],
    },

    "Dragon Roost": {
      auraAddCosts: [{
        who: "all",
        what: { tag: "Dragon" },
        optional: true,
        cond: null,
        label: "Dragon Roost",
        cost: { energy: 0, pips: 0, anyPower: 2, domains: null },
        playToSourceBf: true,
      }],
    },

    "Heisho, Shell of the World": { suppressDeflectHere: true },

    "Kinkou Temple": {
      auraMightSpecs: [{ n: 1, who: "all", scope: "atSource", targetCond: { k: "selfKw", kw: "tank" } }],
    },

    "Mystic Vortex": {
      auraCostMod: [{
        who: "all",
        what: { hasKw: "reaction", orFromFacedown: true },
        cond: { k: "showdownHere" },
        powerMore: 1,
      }],
    },

    "Piltovan Forge": {
      auraCostMod: [{
        ability: { type: "gear" },
        requiresControl: true,
        cond: { k: "turnFact", key: "gearAbilitiesUsed", n: 0, cmp: "exactly" },
        energyLess: 1,
      }],
    },

    "Risen Altar": {
      auraCostMod: [{
        ability: { label: "Empower", type: "unit", atSourceBf: true },
        energyOrPowerLess: 1,
      }],
    },

    "Sandswept Tomb": {
      auraCostMod: [{
        who: "all",
        what: { type: "spell" },
        targetsMatching: { type: "unit", friendly: true, atSourceBf: true },
        powerLess: 1,
      }],
    },

    "Threshold of the Gray": {
      triggers: [{
        on: "combatStart",
        selfBf: true,
        label: "the attacker and the defender each Add 1 Energy",
        targets: [],
        program: [{ op: "addResources", who: "each", res: { energy: 1 } }],
      }],
    },
  });
})();
